<template>
    <!-- 86bce6r42: shown when a renter tries to leave the unlock checkout while
         the discount countdown runs. Modeled on Billing.vue's old "Are you sure?"
         Boost popup. -->
    <TransitionRoot as="template" :show="show">
        <HeadlessDialog as="div" class="relative z-50" @close="emit('decline')">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>
            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative w-full max-w-md transform overflow-hidden rounded-lg bg-white px-6 py-8 text-center shadow-xl transition-all" data-test="leaving-offer">
                            <DialogTitle as="h3" class="text-2xl font-bold text-gray-900">Leaving so soon?</DialogTitle>
                            <p class="mt-3 text-lg text-gray-700">Take an extra {{ percent }}% off to run your report today.</p>
                            <p class="mt-2 font-semibold text-red-600" aria-live="off">Offer ends in {{ countdown }}</p>
                            <div class="mt-6 flex flex-col items-center gap-3">
                                <button
                                    type="button"
                                    class="primaryButton disabled:opacity-50 disabled:cursor-not-allowed"
                                    data-test="accept-leaving-offer"
                                    :disabled="processing"
                                    @click="emit('accept')"
                                >
                                    {{ processing ? 'Applying...' : 'Get My Report' }}
                                </button>
                                <button
                                    type="button"
                                    class="text-sm text-gray-600 hover:text-gray-900"
                                    data-test="decline-leaving-offer"
                                    :disabled="processing"
                                    @click="emit('decline')"
                                >
                                    No thanks
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </HeadlessDialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog as HeadlessDialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    percent: {
        type: Number,
        required: true,
    },
    countdown: {
        type: String,
        required: true,
    },
    processing: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['accept', 'decline'])
</script>
